export default "__VITE_ASSET__B7qo19d3__"